// Cart upsell quick add
window.addEventListener("load", bindCartEvents);
document.addEventListener('cart:refreshed', function () {
  setTimeout(bindCartEvents, 500);
});
function bindCartEvents() {
  document.querySelectorAll('.upsell-quick-add').forEach(function (quickAddButton) {
    quickAddButton.addEventListener('click', function (e) {
      e.preventDefault();
      let variantId = parseInt(quickAddButton.dataset.id);
      fetch('/cart/add.js', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            quantity: 1,
            id: variantId
          }]
        })
      }).then(response => {
        if (!response.ok) {
          throw new Error('An error occurred while adding the product to the cart');
        }
        return response.json();
      }).then(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }).catch(e => {
        console.error(e);
      });
    });
  });
}
document.addEventListener('DOMContentLoaded', function () {
  var elements = document.getElementsByClassName('jdgm-carousel-item__review-body');
  for (var i = 0; i < elements.length; i++) {
    let startY;
    elements[i].addEventListener('touchstart', function (event) {
      startY = event.touches[0].clientY;
      stopPropagation = false;
      event.stopPropagation();
    }, false);
    elements[i].addEventListener('touchmove', function (event) {
      let moveY = event.touches[0].clientY;
      if (Math.abs(moveY - startY) > 10) {
        // Change 10 to the sensitivity you want
        event.stopPropagation();
        stopPropagation = true;
      } else {
        stopPropagation = false;
      }
    }, false);
    elements[i].addEventListener('touchend', function (event) {
      if (stopPropagation) {
        event.stopPropagation();
      }
    }, false);
    elements[i].addEventListener('scroll', function (event) {
      event.stopPropagation();
    }, false);
  }
});